import EmojiData from "../EmojiData.js";

export default function MoodTracker(props) {
  const emojisArr = EmojiData.data.emojis;
  const emojiEl = emojisArr.map((emoji) => {
    return (
      <img
        src={emoji.source}
        alt={emoji.name}
        key={emoji.id}
        className="emoji"
        onClick={() => props.handleClick(emoji.id)}
      />
    );
  });

  return (
    <div className="popupBg">
      <div className="popupDiv">
        <h3 className="popupHead">How are you feeling today?</h3>
        <div className="emojiGrid">{emojiEl}</div>
      </div>
    </div>
  );
}
